
<script>
    //audio files
	import { audioData } from './audioData.js';
	//stores
	import {play_sound, game_over, first_time, num_solved} from './stores.js';
	import { onMount } from 'svelte';

	//0 menu, 1 problem selection, 2 problem solver, 3 user info, 4 guide, 5 settings, 6 about(in guide), etc.
	export let MenuChoice=0;
	export let Name="LCD Console";
	export let Description="&gt;Booting machine...<br/> &gt;ROM loaded.<br/> &gt;";
	
	let audioButtonclick  = new Audio(audioData['buttonclick'].url);
	
	function PlayClick(){
	    if ($play_sound)
	        audioButtonclick.play();
	}
	onMount(async () => {
		//only play once, first time gets reset in game
		if($num_solved == 10 && $first_time){
            let audioNewEmail  = new Audio(audioData['newemail'].url);
            audioNewEmail.play();
            first_time.set(false);
		}
		if($num_solved == 15 && $first_time){
            let audioNewEmail  = new Audio(audioData['newemail'].url);
            audioNewEmail.play();
            first_time.set(false);
		}
		if($game_over && $first_time){
            let audioNewEmails  = new Audio(audioData['newemails'].url);
            audioNewEmails.play();
            first_time.set(false);
		}
	});
</script>
<style>
	#Proball{
		font-size:16px;
		width:500px;
		margin:auto auto;
		text-align: center;
	}
	#console{
		border: 1px solid #fff;
		height:100px;
		width:400px;
		margin: auto auto;
		text-align:left;
		margin-top:10px;
		margin-bottom:10px;
		background-color:#005522;
		color:#002200;
		font-family: monospace; 
	}
	#menutable{
		border-width: 0px;
		height:100px;
		width:400px;
		text-align:left;
		margin-top:10px;
		margin-bottom:10px;
	}
	.buts{
		height:60px;
		width:60px;
		color:#ffffff;
		background-color:#000000;
		font-size:16px;
		font-family: monospace; 
		font-weight:bold;
		cursor:pointer;
	}
	.buts_sym{ font-size:20px;
	}
</style>

<div id="Proball">
	<h3>- {Name} -</h3>
	<div id="console">
		{@html Description}
	</div>
	<p/>
	<table align="center" id="menutable" cellpadding="10">
		<tr>
			<td valign="top"><button on:click={PlayClick} on:click="{() =>MenuChoice = 1}"  class="buts"><span class="buts_sym">&#9654;</span><br/>Play</button></td>
			<td valign="top">Play the game! Debug the system!</td>
		</tr>
		<tr>
			<td valign="top"><button on:click={PlayClick} on:click="{() =>MenuChoice = 4}" class="buts"><span class="buts_sym">&#128366;</span><br/>Email</button></td>
			<td valign="top">How to play, what's going on, and who did what?</td>
		</tr>
		<tr>
			<td valign="top"><button on:click={PlayClick} on:click="{() =>MenuChoice = 3}" class="buts"><span class="buts_sym">&#9881;</span><br/>Setup</button></td>
			<td valign="top">Settings and save files.</td>
		</tr>
		<tr>
			<td valign="top"><button on:click={PlayClick} on:click="{() =>MenuChoice = 5}" class="buts"><span class="buts_sym">&#x1F6C8;</span><br/>About</button></td>
			<td valign="top">Who's making stuff like this and why?</td>
		</tr>
	</table>
</div>